import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, _, u ) => {

	return {
		dialogRoot: {
			[u.smallerThan ( "lg" )]: {
				width  : "600px",
				height : "400px"
			},
			[u.largerThan ( "md" )]: {
				width  : "800px",
				height : "600px"
			},
			[u.largerThan ( "lg" )]: {
				width  : "1200px",
				height : "800px"
			},
			borderRadius    : "15px",
			backgroundColor : theme.other.colors.dialog.secondary
		},
		reactionBoxBottomBoxStyle: {
			position : "fixed",
			bottom   : "0",
			width    : "100%",
			maxWidth : "600px"
		},
		commentTopContainer: {
			display        : "flex",
			marginLeft     : "15px",
			borderRadius   : "20px",
			width          : "fit-content",
			paddingRight   : "10px",
			fontSize       : "12px",
			alignItems     : "center",
			paddingTop     : "5px",
			paddingBottom  : "5px",
			justifyContent : "center"
		},
		commentAvatar: {
			height       : "35px",
			width        : "35px",
			objectFit    : "cover",
			borderRadius : "50%"
		},
		commentNameContainer: {
			marginLeft : "10px",
			flex       : "1"
		},
		commentInput: {
			height: "10px"
		},
		commentInputContainer: {
			"& .MuiOutlinedInput-root": {
				"& fieldset": {
					borderRadius: "50px"
				}
			}
		},
		tabsIndicator: {
			backgroundColor: "#FDCA50"
		},
		svgIcon: {
			...theme.other.svgIcons.size20
		},
		appBar: {
			backgroundColor : theme.other.colors.dialog.primary,
			color           : theme.other.colors.text.primary,
			borderBottom    : theme.other.darkMode ? "none" : `1px solid ${ theme.other.colors.border.primary }`,
			boxShadow       : "none"
		},
		rootTabs: {
			overflow      : "hidden",
			height        : "100%",
			display       : "flex",
			flexDirection : "column",
			flex          : "1",
			background    : theme.other.colors.dialog.primary
			// width   : "80%",
			// padding: "0 3rem"
		},
		tabsFlexContainer: {
			justifyContent: "space-evenly"
		},
		tabIndicator: {
			// maxWidth: 50,
			borderTopRightRadius : "25px",
			borderTopLeftRadius  : "25px",
			height               : "3px",
			left                 : "0 !important",
			width                : "50% !important"
		},
		tabIndicatorLikes: {
			borderTopRightRadius : "25px",
			borderTopLeftRadius  : "25px",
			height               : "3px",
			right                : "0 !important",
			width                : "50% !important",
			left                 : "auto !important"
		},
		tabRoot: {
			minWidth : 0,
			margin   : "0 2rem"
		},
		crossIconDark: {
			filter    : "invert(1)",
			transform : "scale(0.7)",
			cursor    : "pointer"
		},
		crossIcon: {
			cursor : "pointer",
			height : "3rem",
			width  : "3rem"
		},
		crossIconContainer: {
			textAlign : "end",
			padding   : "1rem 1rem 0 0 "

		},
		unActiveText: {
			textTransform: "none"
		},
		activeText: {
			textTransform : "none",
			color         : theme.other.paletteNew.primaryDarkBlue
		},
		tabsList: {
			borderBottom: "0"
		},
		tab: {
			flex              : "1",
			borderBottomWidth : "3px"
		}
	};
} );
